import { CachePolicies, useFetch } from 'use-http';
import { routes } from '@/webapi/routes';
import {
  SavedStrategies,
  SavedStrategyReq,
} from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/saved-strategy/saved-filters';

export function useSlotsStrategyApi() {
  const { get, post, cache } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    ...{
      credentials: `include`,
      cachePolicy: CachePolicies.NO_CACHE,
      loading: false,
    },
  }));

  const getListSlotsStrategies = async (): Promise<SavedStrategies> => {
    const response = await get(routes.getListSlotsStrategies);
    return (response?.strategies || []).map((s: any) => ({
      ...s,
      slots: s.slots?.slots || [],
    }));
  };

  const saveSlotsStrategy = async (s: SavedStrategyReq): Promise<void> => {
    await post(routes.saveSlotsStrategy(), s);
    cache.clear();
  };

  const deleteSlotsStrategy = async (id: string): Promise<void> => {
    await post(routes.deleteSlotsStrategy(), { value: id });
    cache.clear();
  };

  return {
    deleteSlotsStrategy,
    getListSlotsStrategies,
    saveSlotsStrategy,
  };
}
